import { Camera, Target } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
interface PhotoGuidelinesProps {
  compact?: boolean;
}

/**
 * Photography guidelines component - displays instructions for product photography
 */
export function PhotoGuidelines({
  compact = false
}: PhotoGuidelinesProps) {
  const {
    t
  } = useLanguage();
  if (compact) {
    return;
  }
  return <div className="rounded-2xl border border-border bg-card p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
          <Camera className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h4 className="font-bold text-foreground">{t.photoGuidelines.title}</h4>
          <p className="text-xs text-muted-foreground">{t.photoGuidelines.subtitle}</p>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-start gap-3 p-3 bg-secondary/50 rounded-xl">
          <Target className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-foreground">{t.photoGuidelines.frontViewTitle}</p>
            <p className="text-xs text-muted-foreground">{t.photoGuidelines.frontViewDesc}</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3 p-3 bg-secondary/50 rounded-xl">
          <Camera className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-foreground">{t.photoGuidelines.cameraHeightTitle}</p>
            <p className="text-xs text-muted-foreground">{t.photoGuidelines.cameraHeightDesc}</p>
          </div>
        </div>
      </div>
    </div>;
}